import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16a5a025"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slide-cell"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slide-bar", {
      'collapse-slide': !$setup.isExpand,
      'slide-disabled': $setup.isDisabled
    }])
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (menus, index) => {
    return _openBlock(), _createBlock(_component_router_link, {
      class: _normalizeClass(["slide-item", {
        'active-menu': menus.activePath.includes($setup.route.path)
      }]),
      to: menus.path,
      "data-title": menus.title
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        class: "icon",
        src: menus.activePath.includes($setup.route.path) ? menus.activeIcon : menus.defaultIcon
      }, null, 8, _hoisted_2), _withDirectives(_createElementVNode("div", {
        class: "title"
      }, _toDisplayString(menus.title), 513), [[_vShow, $setup.isExpand]])]),
      _: 2
    }, 1032, ["class", "to", "data-title"]);
  }), 256))]), _createElementVNode("i", {
    class: "icon-btn",
    onClick: $setup.changeExpand
  })], 2);
}